// copy of the logo URL in packages/integrations/databricks/shared/src/registry.ts
/** Databricks' logo URL. Kept separate from `databricks-ai`'s registration so
 * the MCP server specs can use it without registering the integration. */
export const DatabricksAiIconUrl =
  "https://www.databricks.com/en-website-assets/icons/icon-192x192.png";
